module.exports = __webpack_public_path__ + "media/images/patent/x_4-bcf45b298b63276d804458ee439a57ad.png";